/**
 * AxLabs Experiments - Chemistry Module Index
 *
 * Exports all chemistry experiments (both manual and generated).
 */
// ============================================================================
// MANUAL EXPERIMENTS
// ============================================================================
export { ChemicalEquilibriumSimulation, createChemicalEquilibrium, CHEMICAL_EQUILIBRIUM_CONFIG, } from './chemical-equilibrium.js';
export { ReactionKineticsSimulation, createReactionKinetics, REACTION_KINETICS_CONFIG, } from './reaction-kinetics.js';
export { TitrationSimulation, createTitration, TITRATION_CONFIG, } from './titration.js';
// ============================================================================
// GENERATED EXPERIMENTS
// ============================================================================
// Export all generated experiments and category arrays
export { 
// Individual experiment exports by category
VaporPressureClausiusClapeyron, RaoultsLawIdealMixture, BoilingPointElevation, FreezingPointDepression, OsmoticPressure, HenrysLaw, PhaseDiagramWaterLike, ColligativeProperties, GalvanicCellNernst, ElectrolysisFaraday, ConcentrationCell, pHElectrodeCalibration, ConductivityTitration, ElectroplatingRate, HesssLawVerification, BombCalorimetry, EnthalpyOfNeutralization, EnthalpyOfSolution, 
// Category arrays
physicalChemistryExperiments, electrochemistryExperiments, thermochemistryExperiments, allChemistryExperiments, experimentCount as chemistryExperimentCount, } from './generated/index.js';
// ============================================================================
// ALL CHEMISTRY EXPERIMENTS ARRAYS
// ============================================================================
import { CHEMICAL_EQUILIBRIUM_CONFIG } from './chemical-equilibrium.js';
import { REACTION_KINETICS_CONFIG } from './reaction-kinetics.js';
import { TITRATION_CONFIG } from './titration.js';
import { allChemistryExperiments as generatedChemistryExperiments } from './generated/index.js';
/**
 * Manual chemistry experiments - these use ExperimentConfig from simulation-core
 * Each has a dedicated SimulationEngine implementation
 */
export const MANUAL_CHEMISTRY_EXPERIMENTS = [
    CHEMICAL_EQUILIBRIUM_CONFIG,
    REACTION_KINETICS_CONFIG,
    TITRATION_CONFIG,
];
/**
 * Generated chemistry experiments - these are GeneratedExperimentClass instances
 * created from ExperimentSchema using the declarative framework
 */
export const GENERATED_CHEMISTRY_EXPERIMENTS = [
    ...generatedChemistryExperiments,
];
/**
 * Combined configs for backward compatibility.
 * For generated experiments, extracts the config from the class.
 */
export const CHEMISTRY_EXPERIMENTS = [
    ...MANUAL_CHEMISTRY_EXPERIMENTS,
    ...GENERATED_CHEMISTRY_EXPERIMENTS.map((ExpClass) => {
        const instance = new ExpClass();
        return instance.config;
    }),
];
//# sourceMappingURL=index.js.map